export const isEveryObjectValuesIsNull = (value: Record<string, any>) => Object.values(value).every((x) => x === null);
